module.exports = __webpack_public_path__ + "img/hp-two-2.e6e7dd69.jpg";